// What the composer hands the sending engine (docs/EMAIL_HTML_BACKEND.md).
//
// Themed emails (Email templates 2.0) carry the finished document as
// `emailHtml`: the same HTML the builder shows, merge tags intact, with the
// salon's gift voucher and shop addresses already swapped in. Classic emails
// have none and are still rendered by the server from their blocks. One
// function so campaign saves and journey email steps (design mode) can't drift.
import { renderEmail, isThemedEmail } from './render'
import { resolveLocalLinks } from './links'

export const emailHtmlPayload = (blocks, links, subject) => {
  if (!isThemedEmail(blocks)) return {}
  try {
    return { emailHtml: renderEmail(resolveLocalLinks(blocks, links), { subject }) }
  } catch (e) {
    return {}
  }
}

// Design mode ("Save design", e.g. a journey's email step): the blocks, the
// subject and, for a themed design, the finished emailHtml.
export const designSavePayload = ({ blocks, subject, name, links }) => ({
  blocks,
  subject,
  name,
  ...emailHtmlPayload(blocks, links, subject),
})
